import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Home } from "@/pages/home";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
